module.exports = __webpack_public_path__ + "img/keyboard_8.7202126f.png";